module.exports = __webpack_public_path__ + "static/media/register-property-resort-budgetHotel-townhouse.57a48e2e.png";